import { LocalizedText } from "@/i18n/LocalizedText";
import { BriefcaseBusiness, MoreHorizontal, Trash } from "lucide-react";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./ui/alert-dialog";

import { useNavigate } from "react-router";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { useState } from "react";

type BrandActionProps = {
  handleDelete: (id: string) => void;
  brand: { brandId?: string; id?: string };
  setDropDownOpened: (opened: boolean) => void;
  canDeleteBrand?: boolean;
};

const BrandAction = ({
  handleDelete,
  brand,
  setDropDownOpened,
  canDeleteBrand = true,
}: BrandActionProps) => {
  const navigate = useNavigate();
  const [brandActionsopen, setBrandActionsOpen] = useState(false);

  return (
    <DropdownMenu open={brandActionsopen} onOpenChange={setBrandActionsOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-7 p-0 cursor-pointer">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" side="bottom" className="w-38">
        <DropdownMenuItem
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            navigate(`/dashboard/settings/brand`);
            setBrandActionsOpen(false);
            setTimeout(() => {
              setDropDownOpened(false);
            }, 300);
          }}
          className="font-normal cursor-pointer flex items-center gap-2"
        >
          <BriefcaseBusiness className="h-4 w-4" />
          <span>
            <LocalizedText id="legacy.brand.settings.pkcpkr" />
          </span>
        </DropdownMenuItem>
        <Separator></Separator>
        <DropdownMenuItem
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          disabled={!canDeleteBrand}
          className="font-normal cursor-pointer flex items-center gap-2 text-[#DC2626] focus:text-red-600"
        >
          {canDeleteBrand ? (
            <AlertDialog>
              <AlertDialogTrigger className="w-full gap-2 flex justify-start">
                <Trash className="h-4 w-4 text-[#DC2626]" />
                <span className="cursor-pointer">
                  <LocalizedText id="legacy.delete.brand.2ljx5z" />
                </span>
              </AlertDialogTrigger>
              <AlertDialogContent>
                <AlertDialogHeader>
                  <AlertDialogTitle className="text-center">
                    <LocalizedText id="legacy.delete.this.brand.1h8o88u" />
                  </AlertDialogTitle>
                  <AlertDialogDescription className="text-center">
                    <LocalizedText id="legacy.this.action.will.permanently.remove.all.data.prompts.3l3598" />
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                  <AlertDialogAction
                    onClick={() => {
                      const brandId = brand.brandId || brand.id;
                      if (brandId) {
                        handleDelete(brandId);
                      }
                      setBrandActionsOpen(false);
                      setTimeout(() => {
                        setDropDownOpened(false);
                      }, 200);
                    }}
                    className="hover:bg-[#ff8138] hover:text-white text-white cursor-pointer bg-[#FF5E00]"
                  >
                    <LocalizedText id="legacy.delete.permanently.1std29f" />
                  </AlertDialogAction>
                  <AlertDialogCancel className="cursor-pointer">
                    <LocalizedText id="legacy.cancel.18x3nqb" />
                  </AlertDialogCancel>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
          ) : (
            <div className="w-full gap-2 flex justify-start opacity-50">
              <Trash className="h-4 w-4 text-[#DC2626]" />
              <span>
                <LocalizedText id="legacy.delete.brand.2ljx5z" />
              </span>
            </div>
          )}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default BrandAction;
